export default __webpack_public_path__ + "static/media/warranty.36b55e17.svg";